import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../../components/Layout/Layout'
import Seo from '../../components/Seo/Seo'
import { PostTemplate } from '../../components/post/PostTemplate'

const postTemplate = ({ data, pageContext }) => {
  const post = data.wpPost
  const readmorePosts = data.readmore?.edges
  const theme = pageContext.theme
  const homePath = pageContext.homePath

  const logos = {
    'dGVybToy': 'arkitektur',
    'dGVybToxMjk4NQ==': 'betong',
    default: 'default',        
  }

  const postCategoryId = post.categories.cats.find(category => logos[category.id])?.id || 'default'
  const logoSrc = logos[postCategoryId] || logos.default

  return (
    <Layout logoSrc={logoSrc} extraClasses={`post-page ${theme}`} homePath={homePath}>
      <PostTemplate post={post} readmorePosts={readmorePosts} />
    </Layout>
  )
}

export const Head = ({ data }) => {
  return (
    <Seo
      title={data.wpPost.title}
      ogImage={data.wpPost?.featuredImage?.image?.sourceUrl}
      imageAltText={data.wpPost?.featuredImage?.image?.altText}
      path={data.wpPost.uri}
      description={data.wpPost.postFlexContent.subheader}
    />
  )
}

export const query = graphql`
  query ($id: String!) {
    wpPost(id: { eq: $id }) {
      id
      uri
      slug
      date
      title
      legacyContent: content
      author {
        details: node {
          id
          email
          firstName
          lastName
          name
          description
          authorUri: uri
          socialLinks {
            facebook
            instagram
            twitter
            linkedin
          }
          userSettings {
            profileImg {
              altText
              sourceUrl
            }
          }
          roles {
            roles: nodes {
              name
            }
          }
        }
      }
      featuredImage {
        image: node {
          altText
          caption
          description
          sourceUrl
        }
      }
      postFlexContent {
        fieldGroupName
        addBlock {
          ... on WpPost_Postflexcontent_AddBlock_Paragraph {
            fieldGroupName
            content
            header
            size
            paragraphImage {
              altText
              description
              sourceUrl
            }
          }
          ... on WpPost_Postflexcontent_AddBlock_Image {
            fieldGroupName
            size
            image {
              altText
              caption
              description
              sourceUrl
            }
          }
          ... on WpPost_Postflexcontent_AddBlock_Quote {
            fieldGroupName
            quote: content
          }
          ... on WpPost_Postflexcontent_AddBlock_Slideshow {
            fieldGroupName
            slideshow {
              image {
                altText
                sourceUrl
                caption
                description
              }
            }
          }
        }
        imagePosition
        subheader
        customHeader
        headerType
        overrideTitle
      }
      tags {
        tags: nodes {
          id
          uri
          slug
          name
        }
      }
      categories {
        cats: nodes {
          id
          uri
          slug
          name
        }
      }
    }

    readmore: allWpPost(filter: { id: { ne: $id } }, limit: 3) {
      edges {
        relatedPost: node {
          ...AllWPPostsFragment
        }
      }
    }

    # nextPosts: allWpPost(filter: { id: { ne: $id } }, limit: 20) {
    #   next: nodes {
    #     ...SinglePostFragment
    #   }
    # }
  }
`
export default postTemplate
